<template>
  <div :class="{ 'bord-table': currentTheme == 'theme-theme2' }">
    <div v-if="hasParamArea" class="table-param-area">
      <slot name="listParam"></slot>
    </div>

    <div ref="mainDiv" class="main-div" id="mainDiv">
      <div class="main-toolbar" v-if="isShowToolbar">
        <slot v-if="$slots.left" name="left"></slot>
        <div class="but-list">
          <div v-for="(item,index) in configure.toolbar" class="single-but-list" v-if="btnDisplay(item)">
            <div v-if="item.children && item.children.length > 0" class="th-button-group">
              <div class="group-item">
                <i :class="item.iconCls" />
                <span>{{ item.text }}</span>
                <i class="wk wk-move-down1"/>
              </div>
              <div class="th-button-second" :style="{minWidth:(item.childrenWidth?item.childrenWidth:'100px')}">
                <div class="second-item" v-for="second in item.children" v-prevent-re-click v-if="btnDisplay(second)" @click="second.handler()">
                  <i :class="second.iconCls" />
                  <span>{{ second.text }}</span>
                </div>
              </div>
            </div>
            <el-upload
              v-else-if="item.toolType == 'import'"
              :show-file-list="item.showFileList"
              :accept="item.importAccept"
              style="display: inline;"
              :on-success="item.fileUploadSuccess"
              :on-error="item.fileUploadError"
              :action="item.action"
            >
              <div class="th-button th-button-sm">
                <i  :class="item.iconCls" />
                <span>{{ item.text }}</span>
              </div>
            </el-upload>
            <div v-else-if="item.toolType == 'checkAll'" class="toolbar-checkbox">
              <span>{{item.text}}</span><el-checkbox v-model="configure.isCheckAll"  true-label="1" false-label="0" @change="item.handler(configure.isCheckAll)"></el-checkbox>
            </div>
            <!-- 如果是其他的工具栏类型 -->
            <div class="th-button" v-else-if="!!item.toolType" @click="toolbarClick(item)">
              <i :class="item.iconCls" />
              <span>{{ item.text }}</span>
            </div>
            <div v-else class="th-button th-button-sm" v-prevent-re-click @click="item.handler()" v-preventReClick="3000">
              <i :class="item.iconCls" />
              <span>{{ item.text }}</span>
            </div>
          </div>
        </div>
        <div class="fun-list">
          <el-dropdown class="table-fun-list" trigger="click" @command="moreFunClick">
            <div class="user-container">
              <div class="th-button">
                <i class="wk wk-list3"></i>
              </div>
            </div>
            <el-dropdown-menu slot="dropdown" class="el-dropdown-unarrow">
              <el-dropdown-item command="refresh" class="fun-refresh1"><div class="table-fun-list-item"><xr-icon type="refresh1" @click="getData()"/>刷新</div></el-dropdown-item>
              <el-dropdown-item command="export" class="fun-export"><div class="table-fun-list-item"><xr-icon type="export"/>导出</div></el-dropdown-item>
              <el-dropdown-item command="quickSearch" class="fun-search"><div class="table-fun-list-item"><xr-icon type="search"/>{{configure.isShowSearch?'关闭':'开启'}}快捷查询</div></el-dropdown-item>
              <el-dropdown-item command="resetSearch" class="fun-refresh"><div class="table-fun-list-item"><xr-icon type="refresh"/>清空查询条件</div></el-dropdown-item>
              <el-dropdown-item command="tableSetting" class="fun-table"><div class="table-fun-list-item"><xr-icon type="table"/>表格列配置</div></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <slot v-if="$slots.right" name="right"></slot>
      </div>
      <div class="main-table" :class="{ 'no-border-table': !configure.border }">
        <el-table
          v-loading="loading"
          v-if="!configure.isTreeTable"
          @sort-change="changeSort"
          ref="normalTable"
          :data="tableData"
          :height="tableHeight"
          border
          :row-key="(row) => {return row.id}"
          :row-class-name="tableRowClassName"
          @cell-click="handleCellClick"
          @row-dblclick="handleDBClickTableRow">
          <el-table-column v-for="(item,index) in configure.columns" v-if="shouldDisplayColumn(item)"  :fixed="item.fixed ? item.fixed : false"  :sortable="!!item.sortable?'custom':false"  :key="item.field" :prop="item.field" :width="item.width" :show-overflow-tooltip='true'>
            <template slot="header" slot-scope="scope">
              <div v-if="item.cellType == 'edit'" class="editor-flag"></div>
              <!-- checkbox列 -->
              <div class="header-div" v-if="item.field == 'ck'">
                <div class="header-title">
                  <a class="corner-marker" v-show="multipleSelection.length > 1">{{multipleSelection.length}}</a>
                  <el-checkbox id="allSelection" v-model="allCheck"  @click.native.stop="handleAllSelection($event)"/>
                </div>
                <div class="header-condition" v-show="configure.isShowSearch">
                  <xr-icon type="cancel" @click.native.stop="closeQuickSearch"/>
                  <xr-icon type="refresh" @click.native.stop="closeResetSearch"/>
                </div>
              </div>
              <!-- radio 单选列 -->
              <div class="header-div" v-else-if="item.field == 'radio'">
                <div class="header-title"></div>
                <div class="header-condition" style="text-align: center;" v-show="configure.isShowSearch">
                  <xr-icon type="cancel" @click.native.stop="closeQuickSearch"/>
                  <xr-icon type="refresh" @click.native.stop="closeResetSearch"/>
                </div>
              </div>
              <!-- 序号 -->
              <div class="header-div" v-else-if="item.field == 'sn'">
                <div class="header-title">序号</div>
              </div>
              <!-- 正常列 -->
              <div class="header-div" :class="{'sortableColumn': !!item.sortable}" v-else>
                <div class="header-title">{{item.title}}</div>
                <div class="header-condition" v-show="configure.isShowSearch">
                  <el-input v-if="item.condition&&item.condition.searchType == 'input'" size="mini" placeholder="" v-on:click.native="handleNoClick($event)" v-on:keyup.enter.native="submit()" v-model="item.condition.value"/>
                  <el-input-number v-else-if="item.condition&&item.condition.searchType == 'number'" size="mini" placeholder="" v-on:click.native="handleNoClick($event)" v-on:keyup.enter.native="submit()" v-model="item.condition.value"/>
                  <el-select v-else-if="item.condition&&item.condition.searchType == 'select'" filterable placeholder="" v-model="item.condition.value" @change="submit()" v-on:click.native="handleNoClick($event)">
                    <el-option  v-for="sItem in item.condition.selectList" :key="sItem.value" :label="sItem.label" :value="sItem.value"></el-option>
                  </el-select>

                  <el-popover
                    v-else-if="item.condition&&item.condition.searchType == 'dateRange'"
                    placement="bottom"
                    width="400"
                    trigger="click">
                    <el-date-picker
                      @change="submit()" v-on:click.native="handleNoClick($event)"
                      v-model="item.condition.value"
                      type="daterange"
                      align="right"
                      unlink-panels
                      size="mini"
                      value-format="yyyy-MM-dd"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      :picker-options="pickerOptions">
                    </el-date-picker>
                    <el-input size="mini" slot="reference"></el-input>
                  </el-popover>

                  <span v-else>&nbsp;</span>
                </div>
              </div>
            </template>
            <template #default="scope" v-if="!item.children">
              <div class="table-checkbox" v-if="item.field == 'ck'" style="text-align: center;">
                <!--  @click.native.stop="handleSelection($event,scope.row)" -->
                <el-checkbox v-model="scope.row.checked" aria-readonly="true" :disabled="scope.row.noCheck === true ? true : false"></el-checkbox>
              </div>
              <div v-else-if="item.field == 'radio'" style="text-align: center;">
                <el-radio class="radio" v-model="radio_value" :label="scope.row[configure.idField]">&nbsp;</el-radio>
              </div>
              <div v-else-if="item.field == 'sn'" style="text-align: center;">{{scope.row.index}}</div>
              <div v-else-if="item.cellType == 'edit' && (!item.editDisplay || item.editDisplay(scope.row))" :style="{textAlign: item.align?item.align:'left'}">
                <XrEditCell :editConfigure="item" :rowData="rowData(scope.row)" :editUrl="configure.editUrl" :idField="configure.idField" :refreshRowData="refreshRowData" @editDataCallback="editDataCallback" @keyupMethod="editKeyupMethod" :ref="'editCell' + item.field + '-' + scope.row.index"></XrEditCell>
              </div>
              <div v-else-if="item.cellType == 'click'" class="click-cell" v-html="cellView(item,scope.row)" @click="cellClick(item,scope.row)" :style="{textAlign: item.align?item.align:'left'}"></div>
              <div v-else-if="item.cellType == 'operate'" class="operate-div" :style="{textAlign: item.align?item.align:'left'}">
                <a v-for="operate in item.operateList" v-if="!operate.display||operate.display(scope.row)" @click="operate.handler(scope.row)">
                  <i :class="operate.iconCls"></i>
                  {{ operate.formatter?operate.formatter(scope.row):operate.text}}</a>
              </div>
              <div class="cell-normal-div" :class="{'cell-null': (item.viewNull) && !(item.field in scope.row)}" v-else v-html="cellView(item,scope.row)" :style="{textAlign: item.align?item.align:'left'}">
              </div>
            </template>
            <el-table-column v-for="child in item.children" v-if="item.children && item.children.length > 0 && shouldDisplayColumn(child)"  :fixed="child.fixed ? child.fixed : false"  :sortable="!!child.sortable?'custom':false"  :key="child.field" :prop="child.field" :width="child.width" :show-overflow-tooltip='true'>
              <template slot="header" slot-scope="scope">
                <div v-if="child.cellType == 'edit'" class="editor-flag"></div>
                <!-- checkbox列 -->
                <div class="header-div" v-if="child.field == 'ck'">
                  <div class="header-title">
                    <a class="corner-marker" v-show="multipleSelection.length > 1">{{multipleSelection.length}}</a>
                    <el-checkbox id="allSelection" v-model="allCheck"  @click.native.stop="handleAllSelection($event)"/>
                  </div>
                  <div class="header-condition" v-show="configure.isShowSearch">
                    <xr-icon type="cancel" @click.native.stop="closeQuickSearch"/>
                    <xr-icon type="refresh" @click.native.stop="closeResetSearch"/>
                  </div>
                </div>
                <!-- radio 单选列 -->
                <div class="header-div" v-else-if="child.field == 'radio'">
                  <div class="header-title"></div>
                  <div class="header-condition" style="text-align: center;" v-show="configure.isShowSearch">
                    <xr-icon type="cancel" @click.native.stop="closeQuickSearch"/>
                    <xr-icon type="refresh" @click.native.stop="closeResetSearch"/>
                  </div>
                </div>
                <!-- 序号 -->
                <div class="header-div" v-else-if="child.field == 'sn'">
                  <div class="header-title">序号</div>
                </div>
                <!-- 正常列 -->
                <div class="header-div" :class="{'sortableColumn': !!child.sortable}" v-else>
                  <div class="header-title">{{child.title}}</div>
                  <div class="header-condition" v-show="configure.isShowSearch">
                    <el-input v-if="child.condition&&child.condition.searchType == 'input'" size="mini" placeholder="" v-on:click.native="handleNoClick($event)" v-on:keyup.enter.native="submit()" v-model="child.condition.value"/>
                    <el-input-number v-else-if="child.condition&&child.condition.searchType == 'number'" size="mini" placeholder="" v-on:click.native="handleNoClick($event)" v-on:keyup.enter.native="submit()" v-model="child.condition.value"/>
                    <el-select v-else-if="child.condition&&child.condition.searchType == 'select'" filterable placeholder="" v-model="child.condition.value" @change="submit()" v-on:click.native="handleNoClick($event)">
                      <el-option  v-for="sItem in child.condition.selectList" :key="sItem.value" :label="sItem.label" :value="sItem.value"></el-option>
                    </el-select>

                    <el-popover
                      v-else-if="child.condition&&item.condition.searchType == 'dateRange'"
                      placement="bottom"
                      width="400"
                      trigger="click">
                      <el-date-picker
                        @change="submit()" v-on:click.native="handleNoClick($event)"
                        v-model="child.condition.value"
                        type="daterange"
                        align="right"
                        unlink-panels
                        size="mini"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="pickerOptions">
                      </el-date-picker>
                      <el-input size="mini" slot="reference"></el-input>
                    </el-popover>

                    <span v-else>&nbsp;</span>
                  </div>
                </div>
              </template>
              <template #default="scope">
                <div class="table-checkbox" v-if="child.field == 'ck'" style="text-align: center;">
                  <!--  @click.native.stop="handleSelection($event,scope.row)" -->
                  <el-checkbox v-model="scope.row.checked" aria-readonly="true" :disabled="scope.row.noCheck === true ? true : false"></el-checkbox>
                </div>
                <div v-else-if="child.field == 'radio'" style="text-align: center;">
                  <el-radio class="radio" v-model="radio_value" :label="scope.row[configure.idField]">&nbsp;</el-radio>
                </div>
                <div v-else-if="child.field == 'sn'" style="text-align: center;">{{scope.row.index}}</div>
                <div v-else-if="child.cellType == 'edit' && (!child.editDisplay || child.editDisplay(scope.row))" :style="{textAlign: child.align?child.align:'left'}">
                  <XrEditCell :editConfigure="child" :rowData="rowData(scope.row)" :editUrl="configure.editUrl" :idField="configure.idField" :refreshRowData="refreshRowData" @editDataCallback="editDataCallback" @keyupMethod="editKeyupMethod" :ref="'editCell' + child.field + '-' + scope.row.index"></XrEditCell>
                </div>
                <div v-else-if="child.cellType == 'click'" class="click-cell" v-html="cellView(child,scope.row)" @click="cellClick(child,scope.row)" :style="{textAlign: child.align?child.align:'left'}"></div>
                <div v-else-if="child.cellType == 'operate'" class="operate-div" :style="{textAlign: child.align?child.align:'left'}">
                  <a v-for="operate in child.operateList" v-if="!operate.display||operate.display(scope.row)" @click="operate.handler(scope.row)">
                    <i :class="operate.iconCls"></i>
                    {{ operate.formatter?operate.formatter(scope.row):operate.text}}</a>
                </div>
                <div class="cell-normal-div" :class="{'cell-null': (child.viewNull) && !(child.field in scope.row)}" v-else v-html="cellView(child,scope.row)" :style="{textAlign: child.align?child.align:'left'}">
                </div>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>

        <!-- 树状表格 -->
        <el-table
          v-else
          v-loading="loading"
          ref="multipleTable"
          :data="tableData"
          border
          :row-class-name="tableRowClassName"
          @row-click="handleClickTableRow"

          :height="tableHeight"
          :row-key="configure.idField"
          :span-method="arraySpanMethod"
          :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
        >
          <el-table-column v-for="(item,index) in configure.columns" :key="item.field" :prop="item.field" :width="item.width" :show-overflow-tooltip='true'>
            <template slot="header" slot-scope="scope">
              <!-- checkbox列 -->
              <div class="header-div" v-if="item.field == 'ck'">
                <div class="header-title">
                  <a class="corner-marker" v-show="multipleSelection.length > 1">{{multipleSelection.length}}</a>
                  <el-checkbox  v-model="allCheck" @click.native.stop="handleAllSelection($event)" />
                </div>
                <div class="header-condition" v-show="configure.isShowSearch">
                  <xr-icon type="cancel" @click.native.stop="closeQuickSearch"/>
                  <xr-icon type="refresh" @click.native.stop="closeResetSearch"/>
                </div>
              </div>
              <!-- radio 单选列 -->
              <div class="header-div" v-else-if="item.field == 'radio'">
                <div class="header-title"></div>
                <div class="header-condition" v-show="configure.isShowSearch">
                  <xr-icon type="cancel" @click.native.stop="closeQuickSearch"/>
                  <xr-icon type="refresh" @click.native.stop="closeResetSearch"/>
                </div>
              </div>
              <!-- 正常列 -->
              <div class="header-div" v-else>
                <div class="header-title">{{item.title}}</div>
                <div class="header-condition" v-show="configure.isShowSearch">
                  <el-input v-if="item.condition.searchType == 'input'" size="mini" placeholder="输入关键字搜索" v-on:keyup.enter.native="submit(item.condition.searchName,item.condition.value);" v-model="item.condition.value"/>
                  <el-select v-if="item.condition.searchType == 'select'"  placeholder="请选择" v-model="item.condition.value" @change="submit(item.condition.searchName,item.condition.value);">
                    <el-option  v-for="sItem in item.condition.selectList" :key="sItem.value" :label="sItem.label" :value="sItem.value"></el-option>
                  </el-select>
                </div>
              </div>
            </template>
            <template #default="scope">
              <div class="table-checkbox" v-if="item.field == 'ck'">
                <el-checkbox v-model="scope.row.checked" @click.native.stop="handleSelection($event,scope.row)"></el-checkbox>
              </div>
              <div v-else-if="item.field == 'radio'">
                <el-radio class="radio" v-model="radio_value" :label="scope.row[configure.idField]">&nbsp;</el-radio>
              </div>
              <div v-else-if="item.field === configure.multiple.expandField && scope.row.columnType == 'parent'">
                <xr-icon :type="scope.row.isExpand?'reduce':'add2'" @click.native.stop="expandChildren(scope.row)"/>
                &nbsp;<span style="font-weight: 600;">{{ item.multipleFormatter(scope.row)}}</span>
              </div>
              <div v-else-if="item.cellType == 'operate'" class="operate-div" :style="{textAlign: item.align?item.align:'left'}">
                <a v-for="operate in item.operateList" v-if="!operate.display||operate.display(scope.row)" @click="operate.handler(scope.row)">{{ operate.formatter?operate.formatter(scope.row):operate.text}}</a>
              </div>
              <!--            <div v-else>-->
              <!--              {{ item.formatter?item.formatter(scope.row[item.field]):scope.row[item.field]}}-->
              <!--            </div>-->
              <div v-else v-html="cellView(item,scope.row)" :style="{textAlign: item.align?item.align:'left'}"></div>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination" v-if="configure.pagination">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageIndex"
            :page-sizes="pageSizes"
            :page-size="pageSize"
            :total="totalPage"
            layout="prev, pager, next,sizes,total"
          ></el-pagination>
        </div>
      </div>
      <!-- 表格配置 -->
      <table-column-setting ref="tableColumnSetting" v-if="isTableColumnSettingShow" @confirmMethod="initTableColumn()"></table-column-setting>
      <!-- 附件 -->
      <xr-resource-dialog ref="attachResource" v-if="isAttachResourceShow"  :business-id="attachBusinessId" :business-type="attachBusinessType"></xr-resource-dialog>
      <!-- 导出页面 -->
      <table-export ref="tableExport" v-if="isTableExportShow"></table-export>
    </div>
  </div>

</template>

<script>
import elementResizeDetectorMaker from "element-resize-detector";
import XrHeaderSearch from '../XrHeaderSearch/index'
import XrEditCell from './editCell'
import TableColumnSetting from './tableColumn-setting'
import TableExport from './tableExport'

export default {
  // table 表格
  name: 'XrTable',
  props: {
    configure: {
      type: Object,
      default: {
        url: '',
        isShowSearch: false,
        isAllSelection: false,
        pagination: true,
        isTreeTable: false,  //是否是树状table
        isShowToolbar: {
          type: Boolean,
          default:() => true
        },
        border: {
          type: Boolean,
          default:() => true
        },
        columns: []
      }
    }
  },
  inject: {
    clickTableRow: {
      default: 'clickTableRow'
    },
    viewRowInfo: {
      default: 'viewRowInfo'
    }
  },
  provide(){
    return{
      refreshRowData:this.refreshRowData,
      handleClickTableRow:this.handleClickTableRow,
      getRowDataByIndex: this.getRowDataByIndex
    }
  },
  computed: {
    currentTheme() {
      return this.$store.getters.themeType; //获取当前的主题类型
    },
    hasParamArea(){

      console.log('1222222222');
      console.log(this.$slots)
      console.log(this.$slots.listParam)

      return this.$slots.listParam?true:false;
    }
  },
  data() {
    return {
      loading: false,
      isTableColumnSettingShow: false,      //是否显示表格配置页面
      isTableExportShow: false,             //是否显示表格配置页面
      isShowToolbar: true,                  //是否显示工具栏
      editable: {},                         //可编辑的map
      allCheck: false,
      origin: -1,                           // 起点数
      pin: false,                           //是否按住shift键
      inputValue: '',
      tableHeight: 'auto',
      query: {},
      multipleSelection: [],                //批量选中的值
      multipleSelectionItem:[],             //批量选中的对像
      pageIndex: 1,                         //当前页码数
      pageSize: 10,                         //每页显示数
      totalPage: 0,                         //总页数
      tableDivHeight: '400px',
      tableData: [],
      radio_value: '',
      radio_row: {},
      editArr: [],                          //修改的数组
      pageSizes: [5,10,20,50,100,200,500,2000],

      isAttachResourceShow: false,          //是否显示【附件弹出框】
      attachBusinessId: '-1',               //附件的业务ID
      attachBusinessType: '',               //附件的业务类型
      pickerOptions: {
        shortcuts: [
          {
            text: '最近7天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近30天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近90天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近7天(+1)',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              end.setTime(end.getTime() + 3600 * 1000 * 24 * 1);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近30天(+1)',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
              end.setTime(end.getTime() + 3600 * 1000 * 24 * 1);
              picker.$emit('pick', [start, end]);
            }
          },
        ]
      },
    }
  },
  components: {
    XrHeaderSearch,
    XrEditCell,
    TableColumnSetting,
    TableExport
  },
  mounted() {
    window.addEventListener('keydown', code => { // 这个是获取键盘按住事件
      // console.log(code) // 这个是你按住键盘打印出键盘信息，在浏览器中自行查看
      if (code.keyCode === 16 && code.shiftKey) { // 判断是否按住shift键，是就把pin赋值为true
        this.pin = true
      }
    })
    window.addEventListener('keyup', code => { // 这个是获取键盘松开事件
      if (code.keyCode === 16) { // 判断是否松开shift键，是就把pin赋值为false
        this.pin = false
      }
    })
  },
  created() {
    this.autoInit();
  },
  methods: {
    //初始化
    autoInit: function () {
      //根据主题判断
      if(this.currentTheme == 'theme-theme3'){  //如果是主题3
        this.tableHeight = 650;
      }

      //如果没有传入，给一个默认值
      if (this.configure.pagination == undefined) {
        this.configure.pagination = true;
      }

      if (!this.configure.pagination) {
        this.pageSize = 10000;
      }

      if(this.configure.border == undefined){
        this.configure['border'] = true;
      }

      if(this.configure.isShowToolbar != null && this.configure.isShowToolbar != undefined){
        this.isShowToolbar = this.configure.isShowToolbar;
      }

      if (this.configure.pageSize) {
        this.pageSize = this.configure.pageSize
      }

      if (this.configure.tableHeight) {
        this.tableHeight = this.configure.tableHeight
      }

      //如果 listInfoUrl 不为空，根据接口获取信息
      if (!!this.configure.listInfoUrl) {
        this.getListInfo(this.configure.listInfoUrl);
      }else{
        if(!this.configure.defaultNoLoadData){  //默认不加载数据为false或空的时候，加载数据
          this.getData();     //获取列表数据
        }
        this.initTableColumn();   //初始化配置的列
      }
    },
    //初始化页面
    init(){
      //重置下页面高度
      // if(!this.configure.tableHeight){
      //   let heightStyle = this.$refs.mainDiv.offsetHeight
      //   if(!!this.configure.pagination){  //如果有分页
      //     this.tableHeight = heightStyle - 69
      //   }else{  //如果没有分页
      //     this.tableHeight = heightStyle - 50
      //   }
      // }
      //初始化数据
      this.getData();

    },
    //获取 listInfo 信息
    getListInfo(listInfoUrl){
      return this.request({
        method:'post',
        url: listInfoUrl,
        params: {}
      }).then((response) =>{          //这里使用了ES6的语法
        // 请求成功返回的数据
        //如果返回编码不为0，提示失败语
        if(response.code !== 0){
          console.log('报错了：' + response.msg);
        }

        for(let i = 0; i < this.configure.columns.length; i ++){
          let temp = this.configure.columns[i];
          // if(!!temp.condition && temp.condition.searchType === 'select' && !!response.data[temp.field + '_list']){
          if(!!temp.condition  && !!response.data[temp.field + '_list']){
            let list = response.data[temp.field + '_list'];
            temp.condition.selectList = list;
          }
        }

        if(!this.configure.defaultNoLoadData){  //默认不加载数据为false或空的时候，加载数据
          this.getData();     //获取列表数据
        }
        this.initTableColumn();   //初始化配置的列
      })
    },
    //获取数据
    getData(index){
      this.pageIndex = 1;
      this.requestData(index);
    },
    //获取数据（index 是 默认选中第几行，从1开始的序号）
    requestData(index) {
      //去掉全选复选框的显示
      this.cleanSelectList();   //情况选择列表
      this.loading = true;
      this.query.showCount = this.pageSize;
      this.query.page = this.pageIndex;

      if(!!this.configure.listParam){
        for (let obj in this.configure.listParam) {
          this.query[obj] = this.configure.listParam[obj]
        }
      }

      return this.request({
        method:'post',
        url: this.configure.url,
        params: this.query
      }).then((response) =>{          //这里使用了ES6的语法
        this.loading = false;
        // 请求成功返回的数据
        //如果返回编码不为0，提示失败语
        if(response.code !== 0){
          this.$message.error(response.msg);
          return false;
        }

        if(response.data.length > 0){
          this.tableData = response.data;
          this.totalPage = response.count;
        }else if(response.rows && response.rows.length>0){
          this.tableData = response.rows;
          this.totalPage = response.rows.length;
        }else{
          this.tableData = []
          //如果为空的情况下，调用选择行，将下级列表也变成空
          if(this.configure.onClickRow){
            let obj = new Object();
            obj['id'] = '-1';
            this.configure.onClickRow(obj);
          }
        }
        this.tableData.forEach(element => {
          if (this.configure.isAllSelection){
            this.handleAllSelectionInit();
          }else{
            element['checked'] = false
            if(element.children){
              this.setChildToBeSelect(element.children,false);
            }
          }
        });

        if(index != null && index != '' && index != undefined && this.tableData  != null){  //如果有默认显示行
          this.handleClickTableRow(this.tableData[parseInt(index) - 1],'index');
        }else if(this.configure.isSelectFirst && this.tableData  != null){  //选中第一行
          this.handleClickTableRow(this.tableData[0],'first');
        }

        this.$nextTick(()=>{ // 页面渲染完成后的回调
          if(!!this.configure.isTreeTable){
            if(!!this.configure.defaultExpandAll){  //是否默认展开
              this.toggleRowExpansionAll(this.$refs.multipleTable.data, true);
            }else{
              this.toggleRowExpansionAll(this.$refs.multipleTable.data, false);
            }
          }
        })

        //初始化修改index
        this.initEditArr();
      })
    },
    //初始化刷新
    initData(){
      this.closeResetSearch(); //清空搜索条件
      this.getData();  //获取数据
    },
    //刷新数据
    refreshData(){
      this.loading = true;
      this.query.showCount = this.pageSize;
      this.query.page = this.pageIndex;
      if(!!this.configure.listParam){
        for (let obj in this.configure.listParam) {
          this.query[obj] = this.configure.listParam[obj]
        }
      }
      return this.request({
        method:'post',
        url: this.configure.url,
        params: this.query
      }).then((response) =>{          //这里使用了ES6的语法
        this.loading = false;
        // 请求成功返回的数据
        //如果返回编码不为0，提示失败语
        if(response.code !== 0){
          this.$message.error(response.msg);
          return false;
        }

        if(response.data.length > 0){
          this.tableData = response.data;
          this.totalPage = response.count;
        }else if(response.rows && response.rows.length>0){
          this.tableData = response.rows;
          this.totalPage = response.rows.length;
        }else{
          this.tableData = []
        }

        //设置选中事件
        let oldMultipleSelection = this.multipleSelection;
        let newMultipleSelection = [];
        let newMultipleSelectionItem = [];
        for (let i = 0; i < oldMultipleSelection.length; i++) {
          let idValue = oldMultipleSelection[i];
          for (let j = 0; j < this.tableData.length; j++) {
            if(idValue === this.tableData[j][this.configure.idField]){
              this.tableData[j].checked = true;
              newMultipleSelection.push(idValue);
              newMultipleSelectionItem.push(this.tableData[j]);
            }
          }
        }
        this.multipleSelection = newMultipleSelection;
        this.multipleSelectionItem = newMultipleSelectionItem;

        this.tableData.splice(1,0);

        //初始化修改index
        this.initEditArr();
      })

    },
    //根据序号获取行数据
    getRowDataByIndex(index){
      let newIndex = parseInt(index) - 1;
      this.tableData.splice(1,0);
      return this.tableData[newIndex];
    },
    cellView(item,row){  //单元格显示
      // console.log('+++cellView+++++');
      // console.log(item);
      if(item.formatter){
        return item.formatter(row[item.field], row)
      }else if(item.condition&&item.condition.searchType == 'select'){
        let viewValue = '';
        for(let i = 0 ; i < item.condition.selectList.length ; i ++){
          if(item.condition.selectList[i].value == row[item.field]){
            viewValue = item.condition.selectList[i].label;
          }
        }
        return viewValue;
      }else{
        return row[item.field]
      }
    },
    //刷新选择框
    refreshSelectList() {
      let multipleSelection = [];
      let multipleSelectionItem = [];
      this.tableData.forEach(item => {
        this.forEachToChildren(item, multipleSelection, multipleSelectionItem);
        if (item.checked) {
          multipleSelection.push(item.id);
          multipleSelectionItem.push(item);
        }
      });
      this.multipleSelection = multipleSelection;
      this.multipleSelectionItem = multipleSelectionItem;
      //如果全选了，设置全选
      if (this.multipleSelection.length > 0 && this.multipleSelection.length == this.tableData.length) {
        this.allCheck = true;
      } else {
        this.allCheck = false;
      }
      //单行事件【选择后的回到事件】
      if (this.configure.onCheckChange) {
        this.configure.onCheckChange(multipleSelectionItem);
      }
    },
    forEachToChildren(item, multipleSelection, multipleSelectionItem) {
      if (item.children) {
        item.children.forEach(child => {
          this.forEachToChildren(child, multipleSelection, multipleSelectionItem);
          if (child.checked) {
            multipleSelection.push(child.id);
            multipleSelectionItem.push(child);
          }
        });
      }
    },

    //清空选择框
    cleanSelectList(){
      this.multipleSelection = [];
      this.multipleSelectionItem = [];
      this.allCheck = false;
    },
    searchClick(value,columName) {
      this.query[columName] = value;
      this.getData();
    },
    // 分页导航
    handlePageChange(val) {
      this.query.pageIndex = val
      this.requestData();
    },
    //把每一行的索引放进row
    tableRowClassName ({row, rowIndex}) {
      row.index = rowIndex + 1;

      let className = 'normal-row';
      if(row.isStop == '1'){
        className += ' stop-row';
      }
      if(row.isOvertime == '1'){  //如果超时状态等等于1的时候
        className += ' overtime-row';
      }
      if(row.isElectOvertime == '1'){  //(电子电器)如果超时状态等等于1的时候
        className += ' elect_overtime-row';
      }
      if(row.isElectNearOvertime == '1'){ //(电子电器)如果临近超时状态等等于1的时候
        className += ' elect_near_overtime-row';
      }
      if(row.returnNote != '' && row.returnNote != null && row.returnNote != 'undefined'){
        className += ' warning-row';
      }
      if(!!this.configure.isCheckRow && row.checked){
        className += ' checked-row';
      }

      if (!!row.fontBold && row.fontBold === '1'){  //加粗
        className += ' bold-font-row'
      }

      if(row.rowBackColor == 'orange'){  //橙色
        className += ' warning-row';
      }

      if(row.rowFontColor == 'red'){   //红色
        className += ' red-font-row';
      }

      if(row.rowFontColor == 'wathet'){   //浅蓝色
        className += ' blue-font-row';
      }

      if(row.rowFontColor == 'orange'){  //橙色
        className += ' orange-font-row';
      }

      if(row.rowFontColor == 'deepRed'){  //深红
        className += ' deepRed-font-row';
      }

      if(row.rowFontColor == 'green'){  //绿色
        className += ' green-font-row';
      }


      // if(row.isStop == '1'){
      //   return 'stop-row';
      // } else if(row.isOvertime == '1'){     //如果超时状态等等于1的时候
      //    return 'overtime-row';
      // }else if(row.isElectOvertime == '1'){     //(电子电器)如果超时状态等等于1的时候
      //    return 'elect_overtime-row';
      // }else if(row.isElectNearOvertime == '1'){
      //    return 'elect_near_overtime-row';
      // }else if(row.returnNote != '' && row.returnNote != null && row.returnNote != 'undefined'){
      // 	 return 'warning-row';
      // }else if(!!this.configure.isCheckRow && row.checked){
      // 	 return 'checked-row';
      // }
      return className;
    },
    //初始化修改index
    initEditArr(){
      let arr = [];
      let columns = this.configure.columns;
      for(let i = 0; i < columns.length; i ++){
        if(columns[i].cellType === 'edit'){
          let field = columns[i].field;
          for(let j = 0; j < this.tableData.length; j ++){
            arr.push(field + '-' + (j + 1));
          }

        }
      }
      this.editArr = arr;
    },
    //点击当前行【关闭当前行】
    handleClickTableRow(row,col,event){
      if(!col){ //如果点击其他地方
        return false;
      }

      //先将所有的选中取消掉
      this.tableData.forEach(item => {
        item.checked = false
      })
      if(row){
        //将当前行选中
        row.checked = true;
        this.radio_value = row[this.configure.idField];
        this.radio_row = row;
        this.tableData.splice(1,0);
        this.refreshSelectList();
        //单行事件【调用父方法】
        if(this.configure.onClickRow){
          this.configure.onClickRow(row);
        }
      }


    },
    //双击当前行
    handleDBClickTableRow(row,col,event){
      //单行事件【调用父方法】
      if(this.configure.onDBClickRow){
        this.configure.onDBClickRow(row);
      }
    },
    //点击单元格
    handleCellClick(row, column, cell, event) {
      if(column.property !== 'ck' && !this.configure.isCheckRow){
        this.origin = row.index;
        this.handleClickTableRow(row, 'cell');
        return false;
      }
      //防止冒泡
      if (event.target.tagName === 'SPAN') return;

      //如果起点数为初始的-1，则其实数设置为当前行
      if(this.origin === -1){
        this.origin = row.index;
      }

      const origin = this.origin // 起点数
      const endIdx = row.index // 终点数

      if (this.pin) { // 判断按住
        const sum = Math.abs(origin - endIdx) + 1// 这里记录终点
        const min = Math.min(origin, endIdx)// 这里记录起点
        let i = 0
        while (i < sum-1) {
          const index = min + i
          this.tableData[index-1].checked = true;   //将shift中间的都选中
          i++
        }
      } else {
        this.origin = row.index // 没按住记录起点
      }

      //处理复选框
      if(!!row.checked){
        row.checked = false;
      }else{
        row.checked = true;
      }


      this.tableData.splice(1,0);
      this.refreshSelectList();
      //单行事件【调用父方法】
      if(this.configure.onClickRow){
        this.configure.onClickRow(row);
      }
    },
    //点击checkbox【正常表格】
    handleSelection(e,row){
      //防止冒泡
      if (e.target.tagName === 'SPAN') return;
      //1、若有子集先让子选中
      if (row.children) {
        this.setChildToBeSelect(row.children, !row.checked);
        //展开
        row.isExpand = true;
      }
      if(row.checked){
        row.checked = false;
      }else {
        row.checked = true;
      }
      this.tableData.splice(1,0);
      this.refreshSelectList();
    },
    //正选/反选 子的checkbox
    setChildToBeSelect(arr, key){
      arr.forEach((v, i) => {
        v.checked = key;
      })
    },
    //全选【正常表格】
    handleAllSelection(e){
      //防止冒泡
      if (e.target.tagName === 'SPAN') return;
      //如果不是所有都选中，就全选，否则反选
      if(this.allCheck){   //全选了，设置反选
        this.tableData.forEach(item => {
          if (!item.noCheck === true){
            item.checked = false
            if(item.children){
              this.setChildToBeSelect(item.children,false);
            }
          }
        })
      }else {
        this.tableData.forEach(item => {
          if (!item.noCheck === true){
            item.checked = true
            if(item.children){
              this.setChildToBeSelect(item.children,true);
            }
          }
        })
      }
      this.tableData.splice(1,0);
      this.refreshSelectList();
    },
    //正常表格在getDate 时全选
    handleAllSelectionInit(){
      this.allCheck = true;
      this.tableData.forEach(item => {
        item.checked = true
        if(item.children){
          this.setChildToBeSelect(item.children,true);
        }
      })
      this.tableData.splice(1,0);
      this.refreshSelectList();
    },
    //关闭快捷查询
    closeQuickSearch(){
      this.configure.isShowSearch = false;
    },
    //重置搜索框
    closeResetSearch(){
      this.configure.columns.forEach(item => {
        if(item.condition && item.condition.searchName){
          this.query[item.condition.searchName] = ''
          item.condition.value = ''
        }
      });
    },
    //右上角的点击事件
    moreFunClick(command){
      if (command == 'refresh') {  //如果是 【刷新】
        // location.reload();
        this.getData();
      } else if (command == 'export') {
        this.exportFile();
      } else if(command == 'quickSearch'){
        if(this.configure.isShowSearch){
          this.configure.isShowSearch = false;
        }else {
          this.configure.isShowSearch = true;
        }
      }else if(command == 'resetSearch'){
        this.closeResetSearch();
      }else if(command == 'tableSetting'){
        this.tableColumnSetting();
      }
    },
    //查询
    submit(){
      let pageIndex = this.query.pageIndex;
      let showCount = this.query.showCount;
      let page = this.query.page;

      let query = new Object();
      query.pageIndex = pageIndex;
      query.showCount = showCount;
      query.page = page;

      let columns = this.configure.columns;
      for (let i = 0; i < columns.length; i++) {
        if(!!columns[i]&&!!columns[i].condition&&!!columns[i].condition.searchName){
          //处理查询类型为日期范围时
          if(columns[i].condition.searchType === 'dateRange' && !!columns[i].condition.value){
            query[columns[i].condition.searchName+'StartDate'] = columns[i].condition.value[0]
            query[columns[i].condition.searchName+'EndDate'] = columns[i].condition.value[1]
          }else {
            query[columns[i].condition.searchName] = columns[i].condition.value
          }
        }
      }
      this.query = query;
      this.requestData();  //重新加载表格
    },
    //修改排序
    changeSort(val){
      //需要先清除默认排序 ！！!
      if (this.$refs.table) this.$refs.table.clearSort()

      this.pageIndex = 1;
      this.query['orderColumn'] = val.prop;
      this.query['orderType'] = val.order;
      this.getData();   //重新加载表格

      return false;
    },
    //切换【每页显示数】
    handleSizeChange(val){
      this.pageSize = val
      this.pageIndex = 1
      this.requestData()
    },
    //切换【页数】
    handleCurrentChange(val){
      this.pageIndex = val
      this.requestData()
    },
    rowData(row) {
      return row;
    },
    //修改某一列的值
    editRowColumnData(id, columnName, value){
      if(!this.configure.idField || !columnName){
        return false;
      }
      let tableData = this.tableData;
      let index = -1;
      for(let i = 0; i < tableData.length; i ++){
        if(tableData[i][this.configure.idField] == id){
          index = i;
        }
      }
      if(index < 0){
        return false;
      }
      this.tableData[index][columnName] = value;
    },
    refreshRowData(row){
      this.refreshData();
      //refreshData

      //刷新数据 TODO 先直接刷新
      // row.isEdit = true;
      // if(this.$refs.normalTable){
      //   this.$set(this.$refs.normalTable.tableData,row.index - 1,row);
      // }else if(this.$refs.multipleTable){
      //   this.$set(this.$refs.multipleTable.tableData,row.index - 1,row);
      // }
      // this.requestData(false);
    },
    //
    editDataCallback(columnName,columnValue){
      //修改数据事件【调用父方法】
      if(this.configure.editDataCallback){
        this.configure.editDataCallback(columnName, columnValue);
      }
    },
    //合并列
    arraySpanMethod({row, column, rowIndex, columnIndex}){
      if (this.configure.multiple.mergeStartIndex === 1 && this.configure.multiple.mergeEndIndex === 1 && row.columnType == 'parent'){
        return
      }else
      if (row.columnType == 'parent') { // 在这里多加一个行的判断就行
        // 合并第二行
        if (columnIndex === this.configure.multiple.mergeStartIndex) {
          return [this.configure.multiple.mergeStartIndex, this.configure.multiple.mergeEndIndex]
        } else if (columnIndex > this.configure.multiple.mergeStartIndex) {
          return [0, 0]
        }
      }
    },
    //展开列
    expandChildren(row){
      if(row.isExpand){
        this.$refs.multipleTable.toggleRowExpansion(row,false);  //就是树形表格控制折叠和展开的语句  true是展开
        row.isExpand = false;
      }else {
        this.$refs.multipleTable.toggleRowExpansion(row,true);  //就是树形表格控制折叠和展开的语句  true是展开
        row.isExpand = true;
      }
      // this.$refs.TreeName.store.nodesMap[item.id].expanded =true/false; //就是控制树形控件折叠和展开的关键语句
    },
    //展开所有列
    toggleRowExpansionAll(data, isExpansion) {
      data.forEach((item) => {
        item['isExpand'] = isExpansion;
        this.$refs.multipleTable.toggleRowExpansion(item, isExpansion);
        if (item.children !== undefined && item.children !== null) {
          this.toggleRowExpansionAll(item.children, isExpansion);
        }
      });
    },
    cellClick(item,row){
      item.handler(row);
    },
    //导出文件
    exportFile(){
      // let id = this.configure.id;     //表格ID
      this.isTableExportShow = true;

      let query = this.query;
      query.showCount = this.pageSize;
      query.page = this.pageIndex;
      if(!!this.configure.listParam){
        for (let obj in this.configure.listParam) {
          query[obj] = this.configure.listParam[obj]
        }
      }
      // 加入选中
      query.multipleSelectionItem =  JSON.stringify(this.multipleSelectionItem)
      this.$nextTick(()=>{
        this.$refs.tableExport.init(this.configure, query) //初始化页面
      })

    },
    //表格列验证显示
    shouldDisplayColumn(item) {
      // 检查display函数
      if (item.display && typeof item.display === 'function' && !item.display()) {
        return false;
      }
      // 检查isShow
      return item.isShow !== '0';
    },
    //表格列配置
    tableColumnSetting(){
      let id = this.configure.id;     //表格ID
      if(!id){
        alert("表格主键没有设置，无法配置！");
        return false;
      }
      this.isTableColumnSettingShow = true;
      this.$nextTick(()=>{
        this.$refs.tableColumnSetting.init(id, this.configure.columns) //初始化页面
      })
    },
    //初始化列
    initTableColumn(){
      if(!this.configure.id){
        return false;
      }
      let tableColumnStr = localStorage.getItem('#' + this.configure.id + '-table-column');
      if(tableColumnStr == null || tableColumnStr == '' || tableColumnStr == undefined){
        return false;
      }
      let list = JSON.parse(tableColumnStr);
      let tableColumnMap = new Object();
      for (let i = 0; i < list.length; i++) {
        let temp = list[i];
        if(temp == null || !temp.tableColumn || temp.isShow == null || temp.isShow == '' || temp.isShow == undefined ){
          continue;
        }
        tableColumnMap[temp.tableColumn] = temp.isShow;
      }
      let columns = this.configure.columns;
      for (let i = 0; i < columns.length; i++) {
        let temp = columns[i];
        if(temp == null || temp.field == null || temp.field == '' || temp.field == undefined){
          continue
        }
        if(tableColumnMap[temp.field] != null && tableColumnMap[temp.field] != '' && tableColumnMap[temp.field] != undefined){
          temp['isShow'] = tableColumnMap[temp.field];
        }
      }
      this.configure.columns = columns;
      this.configure.columns.splice(1,0);   //刷新表格
    },
    //假的无事件的点击函数
    handleNoClick(ev){
      ev.stopPropagation();
      return false;
    },
    //工具栏的通用点击方法
    toolbarClick(item){
      if(item.toolType == 'deleteBatch'){  //如果是删除操作
        this.deleteBatch(item);
      }else if(item.toolType == 'addOne'){   //直接添加一个
        this.addOne(item);
      }else if(item.toolType == 'attachResource'){   //附件
        this.handleAttachResourceOpenDialog(item);
      }else if(item.toolType == 'search'){   //查询
        this.search(item);
      }else if(item.toolType == 'clearSearchParams'){   //清空查询条件
        this.clearSearchParams();
      }
    },
    //直接新增一个
    addOne(){
      return this.request({
        method:'post',
        url:'/web/service?method=' + this.configure.moduleName + '_save',
        params: this.configure.listParam
      }).then((response) =>{
        if (response.code != 0) {
          this.$message.error(response.msg);
          return false;
        }
        this.requestData();
      })
    },
    //删除操作 请至少选择一条数据
    deleteBatch(item){
      //获取选中的list的数组
      let list = this.multipleSelection;
      if(list.length === 0){
        this.$message.warning("请至少选择一条数据")
        return false;
      }
      let confirmMsgHtml = '是否删除以下选中的项目？';
      for(let i = 0; i < list.length; i ++){
        confirmMsgHtml += '<p style="text-indent: 2em;">' + list[i] + '</p>';
      }
      this.$confirm(confirmMsgHtml, '确认删除',{
        dangerouslyUseHTMLString: true,
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        let ids = '';
        for(let i = 0;i < list.length;i++){
          ids = ids + list[i] + ",";
        }
        ids = ids.substring(0,ids.length-1);
        return this.request({
          method:'post',
          url:'/web/service',
          params:{
            'method': this.configure.moduleName + '_deleteBatch',
            'ids':ids
          }
        }).then((response) =>{
          if (response.code === 0) {
            this.$message({message: '删除成功！', type: 'success', duration: 1500, onClose: () => {
                this.requestData();
                //成功够回调方法
                if(!!item.success){
                  item.success();
                }
              }
            })
          } else {
            this.$message.error(response.msg)
          }
        })
      }).catch(() => {})
    },
    //打开附件下载的列表
    handleAttachResourceOpenDialog(item){
      //获取选中id数组
      let list = this.multipleSelectionItem;
      //判断是否选中
      if(list.length === 0){
        this.$message.warning("请选择一条数据")
        return false;
      }
      if(list.length > 1){
        this.$message.warning("请选择一条数据")
        return false;
      }
      let id = '';
      if(!!list[0] && !!item.toolParam && !!list[0][item.toolParam.businessColumn]){
        id = list[0][item.toolParam.businessColumn];
      }
      if(!!item.toolParam && !!item.toolParam['businessType']){
        this.attachBusinessType = item.toolParam['businessType'];
      }
      if(id === ''){
        this.$message.warning("配置错误")
        return false;
      }
      this.attachBusinessId = id
      this.isAttachResourceShow = true;
      this.$nextTick(()=>{
        this.$refs.attachResource.init() //初始化页面
      })
    },
    //查询
    search(item){
      let pageIndex = 1;
      let showCount = this.query.showCount;
      let page = this.query.page;

      let query = new Object();
      query.pageIndex = pageIndex;
      query.showCount = showCount;
      query.page = page;

      let columns = this.configure.columns;
      for (let i = 0; i < columns.length; i++) {
        if(!!columns[i]&&!!columns[i].condition&&!!columns[i].condition.searchName){
          query[columns[i].condition.searchName] = columns[i].condition.value
        }
      }
      this.query = query;
      this.requestData();
      //成功够回调方法
      if(!!item.success){
        item.success();
      }
    },
    //清空查询条件
    clearSearchParams(){
      //清空上边区域的内容
      if(!!this.configure.listParam){
        for (let obj in this.configure.listParam) {
          this.configure.listParam[obj] = '';
        }
      }

      //清空列的条件
      this.configure.columns.forEach(item => {
        if(item.condition && item.condition.searchName){
          this.query[item.condition.searchName] = ''
          item.condition.value = ''
        }
      });

    },
    //修改页面的键盘事件
    editKeyupMethod(type, editKey){
      let index = this.editArr.indexOf(editKey);
      if(index == -1){
        return false;
      }
      let nextIndex;
      if(type == 'up'){  //如果是向上
        if(index == 0){ //如果是第一个
          nextIndex = this.editArr.length - 1;
        }else{
          nextIndex = index - 1;
        }
      }else if(type == 'down'){  //如果是向下
        if(index === (this.editArr.length - 1)){ //如果是最后一个
          nextIndex = 0;
        }else{
          nextIndex = index + 1;
        }
      }
      if(!this.$refs['editCell' + this.editArr[nextIndex]]){
        return false;
      }
      this.$refs['editCell' + this.editArr[nextIndex]][0].clickCell();  //点击下一个节点
    },
    //按钮是否显示字段
    btnDisplay(btnItem){
      //先验证是否有 display 函数
      if(btnItem.display && !btnItem.display()){
        return false;
      }

      if(btnItem.authCode == null || btnItem.authCode == '' || btnItem.authCode == undefined){
        return true;
      }
      let authCode = btnItem.authCode;
      let serviceCodes =  localStorage.getItem('serviceCodes')

      if((serviceCodes + '').indexOf(authCode) != -1){
        return true;
      }else{
        return false;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.main-table .pagination{text-align: center;}
.el-pagination .el-pagination__total{color: rgba(0,0,0,.45)}
.el-table .cell{
  height: 100%;
}
.el-select{
  width: 100% !important;
}
.operate-div a{text-decoration: none;color: #007aff;height: auto;width: 100%;}
  .table-param-area{margin-bottom: 6px;}

.el-table__cell .cell-click-div.cell-null, .cell-normal-div.cell-null{
  background-image: url('../../assets/img/icon/data-null.png');
  background-size: auto 100%;   /* 宽度自适应，高度 100% */
  background-repeat: no-repeat;
  background-position: center;      /* 居中显示 */
}
.el-table__cell .cell-click-div.cell-null, .cell-normal-div.cell-null{
  background-image: url('../../assets/img/icon/data-null.png');
  background-size: auto 100%;   /* 宽度自适应，高度 100% */
  background-repeat: no-repeat;
  background-position: center;      /* 居中显示 */
  height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/XrTable/index.vue